import { Component, Input } from '@angular/core';
import { EmitEventService } from '../../../../services/utilidades/emit-event-service';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-card-ver-detalle-documento',
    templateUrl: './card-ver-detalle-documento.component.html',
    styleUrls: [`./card-ver-detalle-documento.component.scss`],
    imports: [MatIcon]
})
export class CardVerDetalleDocumentoComponent {

  @Input() tipoArchivo = '';
  @Input() nombreAccion: string = '';
  @Input() iconoAccion: string = '';
  @Input() colorIconoAccion: string = '';
  @Input() tipoArchivoCargado: string = '';
  @Input() nombreArchivo: string = '';
  @Input() fechaArchivo: string = '';
  @Input() infoArchivo: any;
  @Input() iconoAcciones: string = 'fa-solid fa-ellipsis';
  @Input() datoArchivo: any;
  @Input() acciones!: [{ Accion: string, Nombre: string }];

  public pdfRegex = new RegExp(/pdf/);
  public imgRegex = new RegExp(/image/);

  constructor(private emitEventService: EmitEventService) {

  }

  ngOnInit(): void {
  }

  realizarAccion(accion: string, datos: any) {
    this.emitEventService.ejecutarAccion(datos, accion);
  }
}
